import {
	getJwmHelpSampleUsersCreateProjectsCtaType,
	isJwmMonetizationExperimentEnabled,
} from '@atlassian/jira-business-feature-flags';

export const CallToActionType = {
	CREATE_PROJECT_BANNER: 'createProjectBanner',
	CREATE_PROJECT_BUTTON: 'createProjectButton',
	CREATE_PROJECT_NONE: 'createProjectNone',
	TRIAL_BANNER: 'trialBanner',
	NONE: 'none',
} as const;

export const getCallToActionType = (
	isSampleProject: boolean | undefined,
): (typeof CallToActionType)[keyof typeof CallToActionType] => {
	const isProjectStateLoaded = typeof isSampleProject === 'boolean';
	if (isProjectStateLoaded) {
		let createProjectCtaType = 'none';
		if (isSampleProject) {
			// check the cohort, but don't fire the exposure event
			createProjectCtaType = getJwmHelpSampleUsersCreateProjectsCtaType();
			if (createProjectCtaType === 'button') {
				return CallToActionType.CREATE_PROJECT_BUTTON;
			}
			if (createProjectCtaType === 'banner') {
				return CallToActionType.CREATE_PROJECT_BANNER;
			}
			return CallToActionType.CREATE_PROJECT_NONE;
		}
		if (isJwmMonetizationExperimentEnabled()) {
			return CallToActionType.TRIAL_BANNER;
		}
	}
	/*
    we should end up here in the following cases:
    - we don't know whether we're in a sample project
    - we're not in a sample project and the monetization experiment is not enabled
    */
	return CallToActionType.NONE;
};

export { CreateProjectCta } from './create-project-cta';
